<ng-container>
  <ngc-global-nav #globalNav></ngc-global-nav>
  <idp-login-modal-wrapper [fromApp]="'skyclub'"></idp-login-modal-wrapper>
  <router-outlet></router-outlet>
  <ngc-global-footer></ngc-global-footer>
</ng-container>
